// GENERATED by scripts/generate-material-icons.py - do not edit by hand.
// Codepoints of the Flutter `Icons.*` the mobile app uses.
export const MATERIAL_ICONS = {
  account_circle_outlined: 0xee35,
  add: 0xe047,
  add_photo_alternate: 0xe057,
  admin_panel_settings: 0xe062,
  admin_panel_settings_outlined: 0xee53,
  analytics_outlined: 0xee74,
  arrow_back: 0xe092,
  arrow_downward: 0xe097,
  attach_file: 0xe0b1,
  block: 0xe0e1,
  broken_image: 0xe110,
  broken_image_outlined: 0xeeff,
  business_outlined: 0xef0b,
  camera_alt: 0xe130,
  campaign: 0xe138,
  cancel_rounded: 0xf616,
  casino: 0xe143,
  casino_outlined: 0xef32,
  chat_bubble: 0xe154,
  chat_bubble_outline: 0xe155,
  check: 0xe156,
  check_circle: 0xe159,
  check_circle_outline: 0xe15a,
  chevron_right: 0xe15f,
  clear: 0xe168,
  close: 0xe16a,
  cloud_off_outlined: 0xef61,
  copy: 0xe190,
  copy_outlined: 0xef7f,
  dashboard_outlined: 0xefa1,
  delete_outline: 0xe1bb,
  devices_outlined: 0xefbb,
  diamond: 0xf04ed,
  diamond_outlined: 0xf05e7,
  done: 0xe1f6,
  done_all: 0xe1f7,
  edit: 0xe21a,
  edit_outlined: 0xf00d,
  email_outlined: 0xf018,
  emoji_events: 0xe22c,
  error: 0xe237,
  error_outline: 0xe238,
  exit_to_app: 0xe243,
  face: 0xe252,
  favorite: 0xe25b,
  favorite_border: 0xe25c,
  favorite_outline: 0xe25c,
  feed_outlined: 0xf04e,
  fingerprint: 0xe287,
  flag: 0xe28e,
  flash_auto: 0xe291,
  flash_off: 0xe292,
  flash_on: 0xe293,
  flip_camera_ios: 0xe29c,
  gamepad: 0xe2d0,
  help_outline: 0xe30b,
  history: 0xe314,
  home: 0xe318,
  home_outlined: 0xf107,
  hourglass_top_rounded: 0xf800,
  info: 0xe33c,
  info_outline: 0xe33d,
  ios_share: 0xe34d,
  keyboard_arrow_down: 0xe353,
  link: 0xe380,
  live_tv: 0xe387,
  location_on: 0xe3ab,
  location_on_outlined: 0xf193,
  lock: 0xe3ae,
  lock_open: 0xe3b0,
  lock_open_outlined: 0xf196,
  lock_outline: 0xe3b1,
  logout: 0xe3b3,
  looks_one: 0xe3b9,
  mark_email_read_outlined: 0xf1b5,
  message: 0xe3e0,
  mic: 0xe3e1,
  mic_off: 0xe3e5,
  more_vert: 0xe404,
  music_note: 0xe415,
  notifications_none_outlined: 0xf235,
  notifications_outlined: 0xf237,
  open_in_new: 0xe45c,
  people: 0xe486,
  people_outline: 0xe488,
  person: 0xe491,
  person_add: 0xe492,
  person_outline: 0xe497,
  phone_outlined: 0xf290,
  photo_library: 0xe4ba,
  pin: 0xe4c6,
  pin_outlined: 0xf2aa,
  play_arrow: 0xe4cb,
  post_add: 0xe4df,
  public: 0xe4f0,
  refresh: 0xe514,
  remove: 0xe516,
  replay: 0xe523,
  report: 0xe52a,
  report_outlined: 0xf30f,
  save_outlined: 0xf334,
  schedule: 0xe556,
  search: 0xe567,
  security: 0xe569,
  send: 0xe571,
  send_outlined: 0xf355,
  settings_outlined: 0xf36e,
  share: 0xe593,
  share_outlined: 0xf378,
  shopping_cart: 0xe59c,
  smart_display: 0xe5c3,
  smart_display_outlined: 0xf3a6,
  sports_kabaddi: 0xe5ed,
  star: 0xe5f9,
  star_outline: 0xe5fd,
  style: 0xe613,
  text_fields: 0xe649,
  timer_10: 0xe663,
  timer_3: 0xe665,
  timer_off: 0xe667,
  tune: 0xe683,
  upload: 0xe695,
  upload_file: 0xe696,
  verified_rounded: 0xf026e,
  verified_user_outlined: 0xf47d,
  video_library: 0xe6a5,
  video_library_outlined: 0xf488,
  videocam: 0xe6a8,
  videocam_off: 0xe6a9,
  videocam_outlined: 0xf48c,
  visibility: 0xe6bd,
  visibility_off_outlined: 0xf4a0,
  visibility_outlined: 0xf4a1,
  warning_amber_rounded: 0xf02a0,
  workspace_premium: 0xf05ae,
} as const

export type MaterialIconName = keyof typeof MATERIAL_ICONS
